import React from 'react';
import { Box } from '@nimbus-ds/components';
import { SettledAmountDto } from '@tiendanube/common';
import { CurrencyPrice } from 'commons/components';
import { ExchangeRateTooltip } from '../index';

interface SettledAmountProps {
  readonly amount: SettledAmountDto;
}

/**
 * Component used for the Cross Border feature.
 * Displays the total or subtotal in a secondary currency, with exchange rate information.
 */
function SettledAmount({ amount }: SettledAmountProps): React.JSX.Element {
  return (
    <Box display="flex" alignItems="center" gap="1">
      <CurrencyPrice
        price={Number(amount.value)}
        currency={amount.currency}
        block
        textAlign="right"
        size="caption"
      />
      <ExchangeRateTooltip settledAmount={amount} position="right" />
    </Box>
  );
}

export default SettledAmount;
